import script from "./AboutUs.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutUs.vue?vue&type=script&setup=true&lang=js"

import "./AboutUs.vue?vue&type=style&index=0&id=04a2f4ff&lang=scss&scoped=true"

import exportComponent from "/Users/clopez/Documents/Repositorios/Muevetec/landing-muevetec-base/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04a2f4ff"]])

export default __exports__